import styled from 'styled-components'

const NavList = styled.ul`
    padding: 0px;
    margin: 0px;
    list-style-type: none;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;

    @media screen and (max-width: 991px) {
        flex-direction: column;
    }
`

export default NavList